export const CAROUSEL = {
  ITEM_CREATED: 'Carousel item created.',
  NOT_FOUND: 'Carousel item not found.',
  ITEM_DELETED: 'Carousel item deleted.',
  ITEM_UPDATED: 'Carousel item updated.',
  REORDER: 'Carousel items reordered.',
} as const;

export const BRAND_CAROUSEL = {
  ITEM_CREATED: 'Carousel item created.',
  NOT_FOUND: 'Carousel item not found.',
  ITEM_DELETED: 'Carousel item deleted.',
  ITEM_UPDATED: 'Carousel item updated.',
  LIMIT_REACHED:
    'Cannot create carousel item, limit reached. Please contact Perkforce for furthur information.',
} as const;

export const CAROUSEL_SETTINGS = {
  UPDATED: 'Carousel settings updated.',
} as const;

export const BRAND_CAROUSEL_SETTINGS = {
  UPDATED: 'Carousel settings updated.',
} as const;

export const CUSTOM_CATEGORY_ICONS = {
  ADDED: 'Custom category icon added.',
  UPDATED: 'Custom category icon updated.',
  DELETED: 'Custom category icon deleted.',
} as const;
